export default function printMovStock(startDate, endDate, columnsJson, type = "geral") {
  const token = localStorage.getItem("token");
  moviment(token, startDate, endDate, columnsJson, type)

}

function moviment(token, startDate, endDate, columnsJson, type) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/moviment-agrotoxico/print/moviments?auth=${token}&startDate=${startDate}&endDate=${endDate}&columns=${columnsJson}&type=${type}`
  );
}
